<template>
  <div class="vf-form-field" :data-field-type="field.dataType">
    <label class="vf-form-field-label">{{ field.fieldName }} <span v-if="field.required" class="required-indicator">*</span></label>
    <div class="vf-form-field-content">
      <div v-if="editMode">
        <textarea v-if="field.textRows > 1" :rows="field.textRows" v-model="field.value" :required="field.required" :name="fieldName" class="form-control" :maxlength="maxlength" :minlength="minlength"></textarea>
        <input v-if="field.textRows == 1" v-model="field.value" :required="field.required" :name="fieldName"  class="form-control" :maxlength="maxlength" :minlength="minlength" />
        <div v-if="field.description" class="vf-form-field-description" v-html="textToHtml(field.description)"></div>
      </div>

      <div v-else>
        <span v-if="field.value" v-html="textToHtml(field.value)"></span>
        <span v-else class="text-muted">No response</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { buildFieldName, textToHtml } from '../../Forms/form-helper.js';

  export default {
    name: 'TextField',
    props: {
      field: {
        type: Object,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        fieldName : buildFieldName(this.field),
        maxlength: this.field.max || null,
        minlength: this.field.min || null
      };
    },
    methods: {
      textToHtml
    },
  };
</script>

<style scoped>
  .required-indicator {
    color: #d9534f;
    margin-left: 3px;
  }
</style>